function debounce(fn, wait = 300) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
  
  if (!customElements.get("speech-search-button")) {
    class SpeechSearchButton extends HTMLElement {
      constructor() {
        super();
        this.recognition = null;
        this.isListening = false;
        this.form = null;
        this.searchInput = null;
        this.predictiveSearch = this.closest("search-suggestions");
        const userAgent = window.navigator.userAgent.toLowerCase();
  
        if (
          "webkitSpeechRecognition" in window &&
          userAgent.indexOf("chrome") > -1 &&
          window.chrome &&
          userAgent.indexOf("edg/") === -1
        ) {
          this.init();
          this.bindEvents();
        } else if (this.predictiveSearch) {
          this.predictiveSearch.classList.add("speech-search--failed");
        }
      }
  
      bindEvents() {
        this.recognition.addEventListener(
          "result",
          debounce((evt) => {
            if (evt.results) {
              const term = evt.results[0][0].transcript;
              this.searchInput.value = term; // Set the speech input value
  
              // Manually dispatch the 'input' event to trigger predictive search
              const inputEvent = new Event("input", {
                bubbles: true,
                cancelable: true,
              });
              this.searchInput.dispatchEvent(inputEvent); // Trigger the event
              this.searchInput.dispatchEvent(new Event('change')); // Trigger the event
  
              // The form will not be submitted now
            }
          }, 300)
        );
  
        this.recognition.addEventListener("audiostart", () => {
          this.isListening = true;
          this.classList.add("search__speech-listening");
        });
  
        this.recognition.addEventListener("audioend", () => {
          this.isListening = false;
          this.classList.remove("search__speech-listening");
        });
  
        this.addEventListener("click", this.toggleListen);
        this.addEventListener("keydown", (e) => {
          if (e.code === "Space" || e.code === "Enter") {
            this.toggleListen(e);
          }
        });
      }
  
      init() {
        this.classList.remove("hidden");
        this.recognition = new window.webkitSpeechRecognition();
        this.recognition.continuous = false;
        this.recognition.interimResults = false;
        this.form = this.closest("form");
        this.searchInput = this.form.querySelector(".js-search-input");
  
        if (this.predictiveSearch) {
          this.predictiveSearch.classList.add("speech-search--enabled");
        }
      }
  
      // Toggle speech recognition start/stop
      toggleListen(evt) {
        evt.preventDefault();
        if (this.isListening) {
          this.recognition.stop();
        } else {
          this.recognition.start();
        }
      }
    }
  
    customElements.define("speech-search-button", SpeechSearchButton);
  }
  